import axios from 'axios'
import * as utils from './api-utils'

export default {
  getByDate(dispatchDate) {
    return axios.get(utils.getApiUrl('/admin/dispatchReservations'), {
      params: {
        dispatch_date: dispatchDate
      }
    })
  },
  save(payload) {
    return axios.post(utils.getApiUrl('/admin/dispatchReservations'), payload)
  }
}
